export const HowItWorks = (props) => {
  const steps = props.data || []

  return (
    <div id='how-it-works' className='text-center'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-10 col-md-offset-1 section-title'>
            <h2>How It Works</h2>
            <p>From the first call to your first unit generated — here is what to expect when you go solar with NewGen.</p>
          </div>
        </div>

        {/* Desktop horizontal timeline */}
        <div className='hiw-timeline hidden-xs'>
          {steps.map((s, i) => (
            <div key={i} className='hiw-step'>
              <div className='hiw-circle'>
                <i className={s.icon}></i>
              </div>
              {i < steps.length - 1 && <div className='hiw-connector'></div>}
              <div className='hiw-step-number'>{s.step}</div>
              <h4 className='hiw-title'>{s.title}</h4>
              <p className='hiw-text'>{s.text}</p>
            </div>
          ))}
        </div>

        {/* Mobile vertical timeline */}
        <div className='hiw-vertical visible-xs'>
          {steps.map((s, i) => (
            <div key={i} className='hiw-v-step'>
              <div className='hiw-v-left'>
                <div className='hiw-circle-sm'>
                  <i className={s.icon}></i>
                </div>
                {i < steps.length - 1 && <div className='hiw-v-line'></div>}
              </div>
              <div className='hiw-v-content'>
                <span className='hiw-step-badge'>{s.step}</span>
                <h4 className='hiw-title'>{s.title}</h4>
                <p className='hiw-text'>{s.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

